import React, { FC } from 'react'
import { internalLinkHandler } from '../../../utils/link.utils'
import Button from '../button'

type Props = {
  mainCtaData: any
}

export const MainCtaButtons: FC<Props> = ({ mainCtaData }) => {
  const firstBtn = mainCtaData.cta[0] || null
  const secondBtn = mainCtaData.cta[1] || null

  const firstButtonHref = firstBtn?.internalLink
    ? internalLinkHandler(firstBtn.internalLink)
    : firstBtn?.externalUrl || ''

  const secondButtonHref = secondBtn?.internalLink
    ? internalLinkHandler(secondBtn.internalLink)
    : secondBtn?.externalUrl || ''

  return (
    <div className="MainCTA__Buttons">
      {(firstBtn?.externalUrl || firstBtn?.internalLink) && firstBtn.text && (
        <Button
          icon={true}
          href={firstButtonHref}
          text={firstBtn.text}
          type="primary"
          size="small"
          theme="light"
          data-cy="MainCTA-Button-One"
        />
      )}

      {(secondBtn?.externalUrl || secondBtn?.internalLink) && secondBtn.text && (
        <Button
          icon={true}
          href={secondButtonHref}
          text={secondBtn.text}
          type="tertiary"
          size="small"
          theme="light"
          data-cy="MainCTA-Button-Two"
        />
      )}
    </div>
  )
}
